import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface ConfirmDialogData {
  title?: string;
  message: string;
  translationParams?: { [key: string]: string | number };
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  result: boolean | null = null;
  @Input() data!: ConfirmDialogData;

  constructor(protected bsModalRef: BsModalRef) {}

  get hasTitle(): boolean {
    return String(this.data.title || '').length > 0;
  }

  get title(): string {
    return this.data.title || '';
  }

  get message(): string {
    return this.data.message;
  }

  get translationParams(): {
    [key: string]: string | number;
  } {
    return this.data.translationParams || {};
  }

  cancel(): void {
    this.result = false;
    this.bsModalRef.hide();
  }

  confirm(): void {
    this.result = true;
    this.bsModalRef.hide();
  }
}
